export default "__VITE_ASSET__CNqIt4I$__"